import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Text } from 'rebass';
import { createGlobalStyle } from 'styled-components';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Header from '../components/Header';
import TextSection from '../components/TextSection';

const GlobalStyles = createGlobalStyle`
  html {
    background-color: black;
  }
`;

const P = ({ children }) => (
  <Text
    color="white"
    fontFamily="grot10"
    fontSize={['16px', '16px', '21px']}
    letterSpacing="-0.5px"
    lineHeight={['22px', '22px', '25px']}
    mb="12px"
  >
    {children}
  </Text>
);

const PolitiqueDeConfidentialite = () => (
  <div>
    <GlobalStyles />
    <Helmet>
      <title>Politique de confidentialité — Divine</title>
    </Helmet>
    <Banner invertColor />
    <Header activePageName="POLITIQUE DE CONFIDENTIALITÉ" invertColor />
    <Box
      css={{ maxWidth: '1500px' }}
      mx="auto"
      mt={['25px', '30px', '70px']}
      px={[20, 30, 70]}
    >
      <TextSection invertColor title="Responsable du traitement">
        <Box>
          <P>
            La société <strong>DIVINE</strong>, SAS au capital de 2 420 €, immatriculée
            au RCS de Paris sous le numéro SIREN <strong>828 897 173</strong>, dont le
            siège social est situé au 14 rue Favart, 75002 Paris, France, est responsable
            du traitement des données personnelles collectées via le site
            www.divine-musique.com.
          </P>
          <P>
            Contact :{' '}
            <a href="mailto:contact@divine-musique.com" style={{ color: 'white' }}>
              contact@divine-musique.com
            </a>
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Données collectées">
        <Box>
          <P>
            Le site www.divine-musique.com est un site vitrine. Aucun formulaire de
            collecte de données personnelles n'est proposé aux visiteurs. Les seules
            données susceptibles d'être traitées sont celles transmises volontairement
            par les utilisateurs par voie de contact par e-mail (nom, prénom, adresse
            e-mail, message).
          </P>
          <P>
            Le site ne recourt à aucun cookie de traçage, de profilage ou de mesure
            d'audience tiers. Aucune donnée n'est cédée à des tiers à des fins
            publicitaires ou commerciales.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Finalités et bases légales">
        <Box>
          <P>
            Les données personnelles transmises par e-mail sont traitées aux fins
            suivantes, sur la base de l'intérêt légitime de DIVINE ou de l'exécution
            d'un contrat :
          </P>
          <P>
            — Répondre aux demandes et prises de contact adressées à DIVINE{'\n'}
            — Entretenir des relations professionnelles et commerciales
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Durée de conservation">
        <Box>
          <P>
            Les données à caractère personnel collectées par voie de courrier
            électronique sont conservées pour une durée maximale de 3 ans à compter du
            dernier contact, conformément aux recommandations de la CNIL.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Destinataires">
        <Box>
          <P>
            Les données personnelles collectées sont exclusivement destinées aux équipes
            internes de DIVINE. Elles ne font l'objet d'aucune transmission à des tiers,
            sauf obligation légale.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Hébergement des données">
        <Box>
          <P>
            Le site est hébergé par Netlify, Inc., 512 2nd Street, Suite 200, San
            Francisco, CA 94107, États-Unis. Netlify est certifié conforme au cadre
            transatlantique EU-US Data Privacy Framework. Pour plus d'informations :{' '}
            <a
              href="https://www.netlify.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white' }}
            >
              www.netlify.com/privacy/
            </a>
            .
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Vos droits">
        <Box>
          <P>
            Conformément au RGPD et à la loi n° 78-17 du 6 janvier 1978 dite
            « Informatique et Libertés », vous disposez des droits suivants sur vos
            données personnelles :
          </P>
          <P>
            — Droit d'accès (art. 15 RGPD){'\n'}
            — Droit de rectification (art. 16 RGPD){'\n'}
            — Droit à l'effacement (art. 17 RGPD){'\n'}
            — Droit à la limitation du traitement (art. 18 RGPD){'\n'}
            — Droit à la portabilité (art. 20 RGPD){'\n'}
            — Droit d'opposition (art. 21 RGPD)
          </P>
          <P>
            Pour exercer ces droits, adressez votre demande par e-mail à{' '}
            <a href="mailto:contact@divine-musique.com" style={{ color: 'white' }}>
              contact@divine-musique.com
            </a>{' '}
            ou par courrier à l'adresse du siège social. Votre demande sera traitée dans
            un délai d'un mois.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Réclamation (CNIL)">
        <Box>
          <P>
            Si vous estimez, après nous avoir contactés, que vos droits ne sont pas
            respectés, vous pouvez adresser une réclamation à la CNIL :
          </P>
          <P>
            Commission Nationale de l'Informatique et des Libertés{'\n'}
            3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07{'\n'}
            <a
              href="https://www.cnil.fr"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white' }}
            >
              www.cnil.fr
            </a>
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Cookies">
        <Box>
          <P>
            Le site www.divine-musique.com n'utilise pas de cookies de traçage ou
            d'analyse d'audience tiers. Des cookies strictement nécessaires au bon
            fonctionnement technique du site peuvent être déposés par l'hébergeur
            Netlify. Ces cookies ne nécessitent pas de consentement préalable au sens
            de la réglementation en vigueur.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Mise à jour" isLast>
        <Box>
          <P>
            DIVINE se réserve le droit de modifier la présente politique à tout moment.
          </P>
          <P>Dernière mise à jour : mai 2025</P>
        </Box>
      </TextSection>
    </Box>
    <Footer activePageName="POLITIQUE DE CONFIDENTIALITÉ" invertColor />
  </div>
);

export default PolitiqueDeConfidentialite;
